import { render, staticRenderFns } from "./sorting-question-component.vue?vue&type=template&id=29653e24&scoped=true&"
import script from "./sorting-question-component.vue?vue&type=script&lang=ts&"
export * from "./sorting-question-component.vue?vue&type=script&lang=ts&"
import style0 from "./sorting-question-component.vue?vue&type=style&index=0&id=29653e24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29653e24",
  null
  
)

export default component.exports